import React, {Component} from 'react';
import {pdf} from "@react-pdf/renderer";
import {PdfDocument} from "../balanceboard/pdf";
import {saveAs} from 'file-saver';
import {connect} from "react-redux";

const generatePdfDocument = async (fileName, documentData, done) => {
    pdf(<PdfDocument data={documentData} />).toBlob().then((blob) => {
        saveAs(blob, fileName);
        done();
    });
};


class PdfDownload extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };

        this.done = this.done.bind(this);
    }

    done() {
        this.setState({
            loading: false
        })
    }

    render() {

        return (
                <div className={'download'}>
                    {
                        (this.state.loading === true
                                ?
                                    <div className={'loading'}>
                                        <div className="spinner">
                                            <div className="bounce1" />
                                            <div className="bounce2" />
                                            <div className="bounce3" />
                                        </div>
                                    </div>
                                :
                                    <button title={'PDF downloaden'} className={'generate material-icons'} onClick={() => this.setState({loading: true})}>
                                        file_download
                                    </button>
                        )
                    }
                </div>
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.a !== this.state.loading && this.state.loading === true) {
            generatePdfDocument('Erkenntnisse_BalanceAktiv.pdf', this.props, this.done);
        }
    }

}

export default connect(
    (state) => {
        return {
            state: state,
        }
    },
    null
)(
    PdfDownload
);
